<template>
  <div class="back-button-container">
    <el-button
      :type="type"
      :plain="plain"
      class="back-button"
      @click="goBack"
    >
      <arrow-left-icon
        :size="20"
        class="button-icon"
      />
      <span
        v-if="innerText"
        class="button-text"
      >{{ innerText }}</span>
    </el-button>
    <el-button
      :type="type"
      :plain="plain"
      class="forward-button"
      @click="goFront"
    >
      <arrow-right-icon
        :size="20"
        class="button-icon"
      />
      <span
        v-if="innerText"
        class="button-text"
      >{{ innerText }}</span>
    </el-button>
  </div>
</template>

<script>
/* eslint-disable */

export default {
name: "BackButtonComponent",
props: {
  // dataperso: {
  //   type: undefined,
  // },
  innerText: {
    type: String,
  },
  type: {
    type: String,
  },
  plain: {
    type: Boolean,
  },
  
  round: {
    type: Boolean,
  },
},
components: {},
data() {
  return {};
},
created() {},

methods: {
  goBack() {
      this.$router.go(-1)
  },
  goFront() {
      this.$router.go(+1)
  },
},
};
</script>

<style lang="scss" scoped>
.back-button-container {
  display: inline-flex;
  gap: 8px;
}

.back-button,
.forward-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;

  .button-icon {
    display: flex;
    align-items: center;
  }

  .button-text {
    line-height: 1;
  }
}

// Améliorer la visibilité des icônes

// Améliorer le contraste des boutons
.back-button:not(.is-plain),
.forward-button:not(.is-plain) {
  .button-icon :deep(svg) {
    fill: currentColor;
  }
}

.back-button.is-plain,
.forward-button.is-plain {
  .button-icon :deep(svg) {
    fill: var(--el-button-text-color);
  }

  &:hover .button-icon :deep(svg) {
    fill: var(--el-button-hover-text-color);
  }
}
</style>